import React from "react";
import { motion } from "framer-motion";
import { MANIFESTO } from "@/data";

function Chapter({ item, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 border-t border-[#A8AEB2]/15 py-12 md:py-20 group"
      data-testid={`manifesto-chapter-${index}`}
    >
      <div className="md:col-span-3">
        <span className="font-display text-5xl md:text-6xl text-[#7AB648]">
          {item.no}
        </span>
      </div>
      <div className="md:col-span-5">
        <h3 className="font-display uppercase text-5xl md:text-7xl leading-[0.9] text-white transition-transform duration-500 group-hover:translate-x-2">
          {item.word}
        </h3>
      </div>
      <div className="md:col-span-4 flex items-center">
        <p className="font-body text-base md:text-lg text-[#A8AEB2] leading-relaxed">
          {item.body}
        </p>
      </div>
    </motion.div>
  );
}

export default function Manifesto() {
  return (
    <section
      id="about"
      className="relative z-10 bg-[#14171A] py-20 md:py-32"
      data-testid="manifesto-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-8 md:mb-16 max-w-2xl"
        >
          <span className="font-body text-sm uppercase tracking-[0.4em] text-[#7AB648]">
            Our Approach
          </span>
          <h2 className="font-head font-extrabold tracking-tight text-4xl md:text-5xl text-white mt-4">
            Three words we live by on every site.
          </h2>
        </motion.div>

        <div className="border-b border-[#A8AEB2]/15">
          {MANIFESTO.map((item, i) => (
            <Chapter key={item.no} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
